﻿/**
 * 模块登记簿（前端）
 * ------------------------------------------------------------
 * 这里登记系统全部可插拔功能模块。底座（认证/壳层/聊天/我的）不在此列，永驻。
 *
 * 集成新模块：① 把模块目录放入 features/（含 module.ts 清单）② 在此 import 并加入数组。
 * 移除模块：  ① 从此数组删掉对应行 ② 删除模块目录。系统其余部分不受影响。
 *
 * 运行时开关：环境变量 VITE_EMA_MODULES（逗号分隔 code 白名单）。
 *   - 未设置：全部启用（默认，保持现状）
 *   - 设置后：仅启用白名单内模块（依赖自动补齐）；未启用模块不注册路由，
 *     访问其地址落到「页面不存在」，底栏/顶栏入口同时隐藏。
 *
 * 前端 code 与后端 EMA_MODULES code 不完全同名（后端见 EMA-server/src/modules/registry.ts）：
 *   solution(产研) → product + program + solution；architecture → arch；
 *   tasks → task；procurement → business；其余 code 同名。
 *   两边 dependsOn 各用各的 code 空间，不混写。
 */
import type { FeatureModule } from './types'

import appcenter from '@modules/appcenter/web/module'
import architecture from '@modules/architecture/web/module'
import automation from '@modules/automation/web/module'
import calendar from '@modules/calendar/web/module'
import cloudpc from '@modules/cloudpc/web/module'
import cloudspace from '@modules/cloudspace/web/module'
import docs from '@modules/docs/web/module'
import fde from '@modules/fde/web/module'
import knowledge from '@modules/knowledge/web/module'
import mail from '@modules/mail/web/module'
import messenger from '@modules/messenger/web/module'
import procurement from '@modules/procurement/web/module'
import solution from '@modules/solution/web/module'
import tasks from '@modules/tasks/web/module'
import workers from '@modules/workers/web/module'

export const ALL_MODULES: FeatureModule[] = [
  appcenter,
  architecture,
  automation,
  calendar,
  cloudpc,
  cloudspace,
  docs,
  fde,
  knowledge,
  mail,
  messenger,
  procurement,
  solution,
  tasks,
  workers,
]
